import type { GridColumnsInput } from '@thinkalpha/ui-table/types/column';
const definitions = [
    ['date', 'Date', 90],
    ['submitted', 'Submitted', 65],
    ['uploaded', 'Uploaded', 70],
    ['symbol', 'Symbol', 60],
    ['type', 'Type', 45],
    ['filing', 'Filing', 100],
    ['details', 'Details', 400],
    ['link', 'Link', 40],
    ['summary', 'Summary', 68],
] as const;
export const filingsGridColumns: GridColumnsInput = {
    columns: definitions.map(([columnId]) => ({ columnId, fieldId: 'filing', hostedRenderer: true })),
    columnState: definitions.map(([columnId, , width], order) => ({
        columnId,
        order,
        visible: true,
        width,
        pinned: columnId === 'symbol' ? 'left' : columnId === 'link' || columnId === 'summary' ? 'right' : undefined,
    })),
    columnDisplay: definitions.map(([columnId, label]) => ({
        columnId,
        label,
        displaySettings: [],
        ellipsis: columnId === 'filing' || columnId === 'details',
    })),
};
